/* ⚠️ GENERATED from app/services/friendFeed.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/friendFeed.ts — what counts as a friend's post.
//
// ══ THE BUG ════════════════════════════════════════════════════════════════
// 🟥 A PAGE'S POSTS WERE APPEARING IN THE FRIENDS FEED. A page post keeps the
//    PUBLISHING USER's uid in `userId` — it has to, because that is the account
//    the write is authorised against and the account moderation has to be able
//    to reach. The page's own identity travels alongside it in `authorType`,
//    `pageId` and `pageName`.
//
//    So `friendIds.has(post.userId)` was true for anything a friend published
//    AS a page, and the friends tab filled up with pages nobody follows. The
//    same mistake is in the browser, where it shows up as a scoring bonus
//    rather than a filter: a page post by a friend was being pushed up the
//    For You feed as though a friend had posted it.
//
// ══ THE RULE ═══════════════════════════════════════════════════════════════
// A page is not a person, so a page post is never a friend post — no matter
// whose account published it, including your own. Following a page is what
// puts a page in front of you; friendship is between people.
//
// 🟢 ONE PREDICATE, TWO CLIENTS, ASKED THE SAME WAY. The phone filters with it
//    and the browser scores with it, so neither can quietly grow its own idea
//    of what a friend's post is.

/**
 * Was this published as a page?
 *
 * 🟥 EITHER MARK IS ENOUGH, DELIBERATELY. `authorType: 'page'` is what the
 *    phone, the browser and the admin server all stamp today, but posts from
 *    before that field existed carry only `pageId`. Asking for both would have
 *    let every one of those old posts back into the friends feed.
 */
export function isPagePost(post) {
  if (!post) return false;
  return post.authorType === 'page' || !!post.pageId;
}

/**
 * Does this post belong in the friends feed?
 *
 * 🟢 YOUR OWN POSTS COUNT. The friends tab has always included them — it is
 *    the feed of people you know, and you are one of them — but your own PAGE
 *    posts do not, for exactly the same reason a friend's do not.
 */
export function isFriendPost(post, friendIds, myUid) {
  if (!post) return false;
  if (isPagePost(post)) return false;
  const uid = post.userId;
  if (!uid) return false;
  if (myUid && uid === myUid) return true;
  return !!friendIds && typeof friendIds.has === 'function' && friendIds.has(uid);
}

/**
 * Does the friend bonus apply to this post?
 *
 * 🟢 THE BROWSER'S QUESTION, WHICH IS THE SAME QUESTION. Its feed has no
 *    friends tab — friendship is a weight in the score instead — so it needs
 *    "is this a friend's post" without "or mine", because it scores mine
 *    separately and more strongly.
 */
export function scoresAsFriend(post, friendIds) {
  if (!post || isPagePost(post)) return false;
  const uid = post.userId;
  if (!uid) return false;
  return !!friendIds && typeof friendIds.has === 'function' && friendIds.has(uid);
}

/** The friends feed, in one call. */
export function friendFeed(posts, friendIds, myUid) {
  if (!posts || !posts.length) return [];
  return posts.filter(p => isFriendPost(p, friendIds, myUid));
}
